// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metrics-container {
  display: flex;
  gap: 20px;
  margin-top: 14px;
  margin-bottom: 16px;
  flex-wrap: wrap;
    justify-content: center;

}

.metric-box {
  display: flex;
  justify-content: center; 
  align-items: center;   background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  padding: 14px 18px;
  flex: 1 1;
  min-width: 180px;
  text-align: center;
}

.metric-box .metric-content {
  display: flex;
  flex-direction: column;
}

.metric-box .metric-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.metric-box .metric-label {
  font-size: 0.9rem;
  color: #666;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/CycleTime/summary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;IACb,uBAAuB;;AAE3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,IAAI,sBAAsB;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".metrics-container {\n  display: flex;\n  gap: 20px;\n  margin-top: 14px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n    justify-content: center;\n\n}\n\n.metric-box {\n  display: flex;\n  justify-content: center; \n  align-items: center;   background-color: #fff;\n  border: 1px solid #dcdcdc;\n  border-radius: 10px;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);\n  padding: 14px 18px;\n  flex: 1;\n  min-width: 180px;\n  text-align: center;\n}\n\n.metric-box .metric-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.metric-box .metric-value {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.metric-box .metric-label {\n  font-size: 0.9rem;\n  color: #666;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
